import { Carousel } from "@fancyapps/ui/dist/carousel/";
import "@fancyapps/ui/dist/carousel/carousel.css";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import { Autoscroll } from "@fancyapps/ui/dist/carousel/carousel.autoscroll.js";

const container = document.getElementById("myCarousel");

const options = {
  Autoscroll: {
    speed: 2,
    autoStart: true,
    speedOnHover: 0.5
  }
};

// Inizializza il Carousel con Autoplay
if (container) {
  Carousel(container, options, { Autoscroll }).init();
}

// Inizializza Fancybox sulla galleria
Fancybox.bind("[data-fancybox='gallery']", {
  animated: true,
  dragToClose: true,
  Toolbar: {
    absolute: true,
    display: [
      { id: "counter", position: "bottom" },
      { id: "zoom", position: "bottom" },
      { id: "close", position: "bottom" }
    ],
  },
});